module.exports = __webpack_public_path__ + "media/steps/car_bcg@2x-reg-id-81f42918.png";